/**
 * O cliente das rotas do plano de ação.
 *
 * Nenhuma delas aciona modelo: o plano 30-60-90 é determinístico e o
 * acompanhamento dele é do tier gratuito. Marcar uma tarefa como feita não pode
 * custar nada nem depender de assinatura — é o gesto que faz a pessoa voltar.
 *
 * O servidor devolve o PLANO INTEIRO já redecorado a cada marcação, e não só a
 * tarefa mexida. A tela guarda o dashboard no `localStorage`; remontar a
 * ordenação por conta própria seria uma segunda implementação da mesma regra,
 * que diverge no dia em que uma das duas mudar.
 */

import { API_ENDPOINTS } from '../config/api';

const responder = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.message || 'Não foi possível atualizar a iniciativa agora.');
  }
  return data.data || {};
};

/** O plano com estado e o resumo da visita. Carimba a visita, como o dashboard. */
export const lerPlanoDeAcao = () =>
  fetch(API_ENDPOINTS.PLANO_DE_ACAO, { credentials: 'include' }).then(responder);

/**
 * Feita, adiada ou de volta para aberta.
 *
 * @param {string} chave    a identidade da iniciativa (ver identidadeDaTarefa.js)
 * @param {string} estado   'feita' | 'adiada' | 'aberta'
 * @param {string} [adiarPara] 'YYYY-MM-DD'; sem data, adiar é adiar 30 dias
 */
export const marcarTarefa = (chave, estado, adiarPara = null) =>
  fetch(`${API_ENDPOINTS.PLANO_DE_ACAO}/${encodeURIComponent(chave)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ estado, ...(adiarPara ? { adiarPara } : {}) })
  }).then(responder);

export default marcarTarefa;
